import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type OnboardingSurveyCompleted } from '../types';

export const useTrackCompletedOnboardingSource = () => {
  const { track } = useAnalyticsUtilities();

  const trackCompletedOnboardingSource = useCallback(
    (params: OnboardingSurveyCompleted) => {
      track(`Completed onboarding referral source`, params, { integrations: { Intercom: true } });
    },
    [track],
  );

  return { trackCompletedOnboardingSource };
};
